import { FC } from "react";
import { IconProps } from "./types";

export const Cookie: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.636 9.818a2.182 2.182 0 1 0 0-4.363 2.182 2.182 0 0 0 0 4.363zm0-.873a1.31 1.31 0 1 0 0-2.618 1.31 1.31 0 0 0 0 2.618zM8.727 14.182a2.182 2.182 0 1 1-4.363 0 2.182 2.182 0 0 1 4.363 0zm-.872 0a1.31 1.31 0 1 1-2.619 0 1.31 1.31 0 0 1 2.619 0zM10.91 20.727a2.182 2.182 0 1 0-.001-4.363 2.182 2.182 0 0 0 0 4.363zm0-.872a1.31 1.31 0 1 0 0-2.619 1.31 1.31 0 0 0 0 2.619zM19.636 16.364a2.182 2.182 0 1 1-4.363 0 2.182 2.182 0 0 1 4.363 0zm-.872 0a1.31 1.31 0 1 1-2.619 0 1.31 1.31 0 0 1 2.619 0z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12 0-1.542-1.53-1.338-3.42-1.085-2.017.27-4.444.593-5.853-1.097-1.302-1.563-1.198-3.873-1.109-5.86C13.716 1.787 13.796 0 12 0 5.373 0 0 5.373 0 12s5.373 12 12 12zm0-.873c6.145 0 11.127-4.982 11.127-11.127a.76.76 0 0 0-.028-.236.164.164 0 0 0-.017-.037l-.002-.002a.162.162 0 0 0-.052-.03.894.894 0 0 0-.223-.058c-.486-.073-1.2.022-2.203.155l-.1.014c-.98.13-2.153.275-3.27.153-1.14-.124-2.303-.536-3.175-1.582-.835-1.002-1.166-2.217-1.29-3.38-.113-1.048-.063-2.135-.021-3.072l.012-.281c.047-1.065.052-1.822-.1-2.314-.066-.219-.143-.309-.198-.351-.051-.04-.17-.106-.46-.106C5.855.873.873 5.855.873 12c0 6.145 4.982 11.127 11.127 11.127z"
      fill={fill}
    />
  </svg>
);
